import React from "react";
import style from "./styles/Header.module.scss";
import ErrorBoundary from "./ErrorBoundary";
import { useSelector } from "react-redux";

function Header() {
  const company = useSelector((state) => state.companyInfo);

  return (
    <ErrorBoundary>
      <div className={style.logo}>
        <div className="display-flex display-justify-center">
          <a href={company.portalUrl} title={company.name}>
            <link rel="preload" as="image" href={company.logo} />
            <img
              width="200"
              height="72"
              src={company.logo}
              alt={company.name}
            />
          </a>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default Header;
